module.exports = __webpack_public_path__ + "static/media/62 - Logo UPH Career Center.de401772.png";